import { render } from "./PedidosComponent.vue?vue&type=template&id=575d9722&scoped=true"
import script from "./PedidosComponent.vue?vue&type=script&lang=js"
export * from "./PedidosComponent.vue?vue&type=script&lang=js"

import "./PedidosComponent.vue?vue&type=style&index=0&id=575d9722&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575d9722"]])

export default __exports__